import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

export type LoginResult = {
    token: string;
};

@Injectable({ providedIn: 'root' })
export class AuthRepo {

    constructor(
        private http: HttpClient
    ) { }

    login(code: string, deviceId: string, deviceTelephoneNumber: string | null | undefined): Observable<LoginResult> {
        return this.http.post<LoginResult>(`${environment.apiBaseUrl}/courier/login-with-code`,
            { code, deviceId, deviceTelephoneNumber }
        ).pipe(shareReplay());
    }

    logout(): Observable<unknown> {
        return this.http.post(`${environment.apiBaseUrl}/courier/logout`, {});
    }
}
